import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

export const CaCredentialsNotice = () => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      alignItems="center"
      p={1}
      sx={{ backgroundColor: '#f8f9fe', borderRadius: 5 }}
    >
      <Typography
        flex={1}
        variant="subtitle1"
        textAlign="center"
        color="GrayText"
      >
        {t('auth:caConnection')}
      </Typography>
    </Box>
  );
};
